(function () {
    console.log('AlsoBoughtQuickView: Script loaded.');
    var productIdCache = {};
    var processedProducts = new WeakSet();

    function extractProductHandle(href) {
        if (!href) return null;
        var m = href.match(/\/products\/([^?#]+)/);
        return m ? m[1] : null;
    }

    function loadScript(url, callback) {
        var src = url.split('?')[0];
        if (document.querySelector('script[src*="' + src + '"]')) {
            if (callback) callback();
            return;
        }
        var script = document.createElement('script');
        script.src = url;
        script.defer = true;
        script.onload = callback;
        script.onerror = callback;
        document.head.appendChild(script);
    }

    function ensureDependencyLoaded(callback) {
        var pending = 0;

        function done() {
            pending--;
            if (pending === 0 && callback) callback();
        }

        if (!customElements.get('quick-add-modal')) {
            pending++;
            loadScript(window.Shopify && window.Shopify.assets ? window.Shopify.assets.quickAdd : '/assets/quick-add.js', done);
        }
        if (!customElements.get('quick-wish-modal')) {
            pending++;
            loadScript(window.Shopify && window.Shopify.assets ? window.Shopify.assets.quickWish : '/assets/quick-wish.js', done);
        }

        if (pending === 0 && callback) {
            callback();
        }
    }

    function fetchProductInfo(handle, callback) {
        if (productIdCache[handle]) {
            callback(productIdCache[handle]);
            return;
        }
        fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then(function (res) {
                if (!res.ok) throw new Error();
                return res.json();
            })
            .then(function (product) {
                var firstAvailableVariantId = null;
                if (product.variants && product.variants.length > 0) {
                    var availableVariant = product.variants.find(function (v) { return v.available; });
                    firstAvailableVariantId = availableVariant ? availableVariant.id : product.variants[0].id;
                }
                var data = {
                    id: product.id,
                    firstAvailableVariantId: firstAvailableVariantId
                };
                productIdCache[handle] = data;
                callback(data);
            })
            .catch(function (err) {
                console.warn('AlsoBoughtQuickView: Failed to fetch product info for', handle, err);
            });
    }

    function ensureModalsExist(id, handle) {
        if (!document.getElementById('quick-add-' + id)) {
            var container = document.createElement('div');
            container.innerHTML =
                '<quick-add-modal id="quick-add-' + id + '" class="sm-modal sm-quick-add-modal" data-product-id="' + id + '" data-product-handle="' + handle + '">' +
                '<div role="dialog" aria-label="Add to Cart" aria-modal="true" class="sm-modal__wrapper" tabindex="-1">' +
                '<div class="sm-modal__content">' +
                '<div class="sm-modal__body">' +
                '<div class="title-add">' +
                '<h2>Add to Cart</h2>' +
                '<button type="button" class="sm-modal__close z-10" aria-label="Close">' +
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path d="M15.833 5.342 14.658 4.167 10 8.825 5.342 4.167 4.167 5.342 8.825 10l-4.658 4.658 1.175 1.175L10 11.175l4.658 4.658 1.175-1.175L11.175 10l4.658-4.658Z"/></svg>' +
                '</button>' +
                '</div>' +
                '<div id="quick-add-info-' + id + '" class="sm-quick-add-modal__content-info"></div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</quick-add-modal>';
            document.body.appendChild(container.firstElementChild);
        }

        if (!document.getElementById('quick-wish-' + id)) {
            var container2 = document.createElement('div');
            container2.innerHTML =
                '<quick-wish-modal id="quick-wish-' + id + '" class="sm-modal sm-quick-wish-modal" data-product-id="' + id + '" data-product-handle="' + handle + '">' +
                '<div role="dialog" aria-label="Add to Wishlist" aria-modal="true" class="sm-modal__wrapper !max-w-lg" tabindex="-1">' +
                '<div class="sm-modal__content">' +
                '<div class="sm-modal__header relative text-center text-sm">' +
                '<span>ADD TO WISHLIST</span>' +
                '<button type="button" class="sm-modal__close inline-flex absolute top-1/2 right-4 -translate-y-1/2" aria-label="Close">' +
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path d="M15.833 5.342 14.658 4.167 10 8.825 5.342 4.167 4.167 5.342 8.825 10l-4.658 4.658 1.175 1.175L10 11.175l4.658 4.658 1.175-1.175L11.175 10l4.658-4.658Z"/></svg>' +
                '</button>' +
                '</div>' +
                '<div class="sm-modal__body p-4 md:p-6">' +
                '<div id="quick-wish-info-' + id + '" class="sm-quick-add-modal__content-info"></div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</quick-wish-modal>';
            document.body.appendChild(container2.firstElementChild);
        }
    }

    function injectButtonsAndModal(productEl) {
        if (processedProducts.has(productEl)) return;
        processedProducts.add(productEl);

        var imageLink = productEl.querySelector('a.cbb-also-bought-product-image-link');
        if (!imageLink) return;

        var href = imageLink.getAttribute('data-href') || imageLink.getAttribute('href');
        var handle = extractProductHandle(href);
        if (!handle) return;

        // 1. 创建包裹层
        var wrapper = document.createElement('div');
        wrapper.className = 'cbb-product-card-media';
        imageLink.parentNode.insertBefore(wrapper, imageLink);
        wrapper.appendChild(imageLink);

        // JS 管理 hover 状态类
        var isInteracting = false;

        wrapper.addEventListener('mouseenter', function () {
            wrapper.classList.add('is-hovered');
        });

        wrapper.addEventListener('mouseleave', function () {
            if (!isInteracting) {
                wrapper.classList.remove('is-hovered');
            }
        });

        // 2. 创建 hover 覆盖层
        var overlay = document.createElement('div');
        overlay.className = 'sm-product-card__icon absolute bottom-0 left-1/2 sm-product-card__icon--bottom-center cbb-injected-icons';

        var wishSvg = '<svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M16.5861163,3.6 C20.0172608,3.6 22.8,6.49544235 22.8,10.0600536 C22.8,12.1576408 21.8409006,13.5989276 21.0574109,14.7699732 L21.030394,14.8085791 C18.7879925,18.1672922 13.1819887,22.3109919 12.9523452,22.4782842 C12.6821764,22.6841823 12.3579737,22.8 12.0067542,22.8 C11.6555347,22.8 11.3313321,22.6970509 11.0476548,22.4782842 C10.8180112,22.2981233 5.2120075,18.1672922 2.96960602,14.8085791 C2.22664166,13.7018767 1.2,12.1962467 1.2,10.0600536 C1.2,6.49544237 3.99624766,3.6 7.41388368,3.6 C9.15647279,3.6 10.8180113,4.35924933 12.0067542,5.6847185 C13.1819887,4.3463807 14.8300188,3.6 16.5861163,3.6 Z M16.5861163,5.6 C15.4035412,5.6 14.3037615,6.09998225 13.5095742,7.00438973 L12.0225285,8.69781302 L10.5178338,7.02005219 C9.70233236,6.11075381 8.57909068,5.6 7.41388368,5.6 C5.11415304,5.6 3.2,7.58752387 3.2,10.0600536 C3.2,11.0718835 3.51033136,11.934894 4.15767921,12.9732937 C4.28391991,13.1757942 4.37380205,13.3120123 4.63296123,13.6980614 C4.92843753,14.1406317 5.31895645,14.6339229 5.79344132,15.1658494 C6.38906041,15.8335747 7.10275451,16.5466994 7.90898822,17.2883371 C8.82565047,18.1315556 9.8116411,18.9665688 10.8120564,19.7652603 C10.9674131,19.8892909 11.1616546,20.0417644 11.3584972,20.195147 L11.554863,20.3478128 C11.7169839,20.4735874 11.8725122,20.5936197 12.0004503,20.691976 L12.0701448,20.6428446 C12.7161233,20.1573461 13.6775418,19.395856 14.6786857,18.5416827 L14.9296397,18.3263145 C16.924112,16.6044921 18.5072023,14.9859414 19.3917861,13.6618602 C20.4494027,12.0820757 20.8,11.2838355 20.8,10.0600536 C20.8,7.58203778 18.8939924,5.6 16.5861163,5.6 Z" fill="currentColor" fill-rule="nonzero"></path></g></svg>';

        var bagSvg = '<svg viewBox="0 0 448 512" width="16" height="16"><path d="M352 128C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 48c44.112 0 80 35.888 80 80H144c0-44.112 35.888-80 80-80zm176 384c0 17.645-14.355 32-32 32H80c-17.645 0-32-14.355-32-32V176h48v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h160v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h48v256z" fill="currentColor"></path></svg>';

        var spinnerSvg = '<svg class="spinner" width="16" height="16" stroke="currentColor" stroke-width="5" viewBox="0 0 66 66" focusable="false" aria-hidden="true"><circle class="path" fill="none" cx="33" cy="33" r="30"></circle></svg>';

        overlay.innerHTML =
            '<div class="flex flex-row justify-center items-center gap-2 p-4 sm-product-card__icon-btns">' +
            '<div class="sm-product-card__icon-wrap cbb-wish-opener">' +
            '<button type="button" name="wish" class="sm-quick-wish__submit inline-flex !opacity-100 sm-icon-shape sm-product-card__icon-btn" aria-haspopup="dialog" data-product-url="/products/' + handle + '" data-product-handle="' + handle + '" title="Add to wishlist">' +
            '<span class="sm-product-card__icon-tooltip">Add to wishlist</span>' +
            '<div class="sm-loading hidden">' + spinnerSvg + '</div>' +
            wishSvg +
            '</button>' +
            '</div>' +
            '<div class="sm-product-card__icon-wrap cbb-add-opener">' +
            '<button type="button" name="add" class="sm-quick-add__submit inline-flex !opacity-100 sm-icon-shape sm-product-card__icon-btn cbb-cart-btn" aria-haspopup="dialog" data-product-url="/products/' + handle + '" title="Quick shop">' +
            '<span class="sm-product-card__icon-tooltip">Quick shop</span>' +
            '<div class="sm-loading hidden">' + spinnerSvg + '</div>' +
            bagSvg +
            '</button>' +
            '</div>' +
            '</div>';

        // 冒泡阶段拦截所有事件向上传播到 slider
        var eventsToBlock = ['click', 'mousedown', 'mouseup', 'pointerdown', 'pointerup', 'touchstart', 'touchend'];
        eventsToBlock.forEach(function (eventName) {
            overlay.addEventListener(eventName, function (e) {
                e.stopPropagation();
            });
        });

        // 交互标记
        overlay.addEventListener('pointerdown', function () {
            isInteracting = true;
            wrapper.classList.add('is-hovered');
        });

        document.addEventListener('pointerup', function () {
            if (!isInteracting) return;
            setTimeout(function () {
                isInteracting = false;
                if (!wrapper.matches(':hover')) {
                    wrapper.classList.remove('is-hovered');
                }
            }, 300);
        });

        wrapper.appendChild(overlay);

        // 3. 异步获取 Product ID → 创建 modal 壳子 → 绑定按钮事件
        fetchProductInfo(handle, function (data) {
            var id = data.id;
            var firstVariantId = data.firstAvailableVariantId;

            productEl.setAttribute('data-product-id', id);
            imageLink.setAttribute('data-product-id', id);

            // 先创建 modal 壳子
            ensureModalsExist(id, handle);

            // =====================================================
            // 关键修复：用 pointerdown 代替 click 触发 modal.open()
            //
            // 原因：styles.js 的 slider 在 pointerdown 的 capture 阶段
            // 调用了 slider.setPointerCapture(event.pointerId)。
            // setPointerCapture 会把后续所有指针事件（包括 pointerup、
            // mouseup）都重定向到 slider 上。
            //
            // click 事件要求 mousedown 和 mouseup 发生在同一个元素上，
            // 但由于 mouseup 被重定向到了 slider，所以 click 永远不会
            // 在我们的 button 上触发。
            //
            // pointerdown 是第一个触发的事件，slider 虽然在 capture
            // 阶段先执行了 setPointerCapture，但它没有 stopPropagation，
            // 所以 pointerdown 仍然会继续向下传播到达我们的 button。
            // =====================================================

            var wishBtn = overlay.querySelector('.cbb-wish-opener button');
            if (wishBtn) {
                wishBtn.setAttribute('data-variant-id', firstVariantId);

                // 用 pointerdown 触发弹窗（因为 click 被 setPointerCapture 阻断了）
                wishBtn.addEventListener('pointerdown', function (e) {
                    if (e.button !== 0) return; // 只响应左键
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('AlsoBoughtQuickView: Wish pointerdown, opening modal for', id);

                    var modal = document.querySelector('#quick-wish-' + id);
                    if (modal && typeof modal.open === 'function') {
                        modal.open(wishBtn);
                    } else {
                        console.warn('AlsoBoughtQuickView: Wish modal not found or no open(). Retrying after define...');
                        customElements.whenDefined('quick-wish-modal').then(function () {
                            var m = document.querySelector('#quick-wish-' + id);
                            if (m && typeof m.open === 'function') m.open(wishBtn);
                        });
                    }
                });
            }

            var addBtn = overlay.querySelector('.cbb-add-opener button');
            if (addBtn) {
                // 用 pointerdown 触发弹窗
                addBtn.addEventListener('pointerdown', function (e) {
                    if (e.button !== 0) return;
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('AlsoBoughtQuickView: Add pointerdown, opening modal for', id);

                    var modal = document.querySelector('#quick-add-' + id);
                    if (modal && typeof modal.open === 'function') {
                        modal.open(addBtn);
                    } else {
                        console.warn('AlsoBoughtQuickView: Add modal not found or no open(). Retrying after define...');
                        customElements.whenDefined('quick-add-modal').then(function () {
                            var m = document.querySelector('#quick-add-' + id);
                            if (m && typeof m.open === 'function') m.open(addBtn);
                        });
                    }
                });
            }

            // 触发心愿单状态更新
            if (typeof handleWishedButtonStatus === 'function') {
                handleWishedButtonStatus();
            }
            if (typeof setupDirectWishButtons === 'function') {
                setupDirectWishButtons();
            }
        });
    }

    function initAll() {
        var products = document.querySelectorAll('.cbb-also-bought-product');
        if (!products.length) return;

        ensureDependencyLoaded(function () {
            products.forEach(injectButtonsAndModal);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    setTimeout(initAll, 2000);
    setTimeout(initAll, 4000);
    window.addEventListener('load', initAll);

    var observer = new MutationObserver(initAll);
    observer.observe(document.documentElement, { childList: true, subtree: true });
})();
